import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchTaxesTypes,
  createTaxeType,
  //updateComprobanteType,
  //deleteComprobanteType,
} from "../../api/accounting/taxesTypesApi";

export const useTaxesTypes = () => {
  const queryClient = useQueryClient();

  const {
    data: taxesTypes = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["taxesTypes"],
    queryFn: fetchTaxesTypes,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const invalidateCache = () => {
    queryClient.invalidateQueries({ queryKey: ["taxesTypes"] });
  };

  const createMutation = useMutation({
    mutationFn: createTaxeType,
    onSuccess: invalidateCache,
  });

  /*const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateComprobanteType(id, data),
    onSuccess: invalidateCache,
  });*/

  /*const deleteMutation = useMutation({
    mutationFn: deleteComprobanteType,
    onSuccess: invalidateCache,
  });*/

  return {
    taxesTypes,
    error,
    isLoading,
    createMutation,
    //updateMutation,
    //deleteMutation,
  };
};
